import React from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import {List} from 'antd';

import AboutInfo from "./aboutInfo/aboutInfo";
import FooterMenu from "./footerMenu/footerMenu";
import FooterWorkingHours from "./footerWorkingHours/footerWorkingHours";
import FollowUs from "./followUs/followUs";

 
const Footer = () => {
    return (
            <div className="footer">
                <Container>
                    <Row>  
                        <Col md={12} className="about-footer">
                            <AboutInfo /> 
                        </Col>
                        <Col md={4} className="footer-menu"> 
                            <FooterMenu />
                        </Col>
                        <Col md={4} className="footer-workinghours"> 
                            <FooterWorkingHours />
                        </Col>
                        <Col md={4} className="footer-socialmedia">
                            <FollowUs />
                        </Col>
                    </Row>
                </Container>
                
                <div className="copyright-wrap">
                    <Container>
                        <Row>
                            <Col md={6}>
                                <p>© 2022 Skycars.in. All Right Reserved.</p>
                            </Col>
                            <Col md={6} className="text-end">
                                <List>
                                    <List.Item>
                                        <Link to="/policycontent">Policies</Link>
                                    </List.Item>
                                    <List.Item>
                                        <Link to="/help">Get Help</Link>
                                    </List.Item>
                                </List>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
            
           
    );
  }
  
  export default Footer;